import React, { useRef, useState } from "react";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import { Col, Form, Offcanvas, Row } from "react-bootstrap";
import Select, { SingleValue } from "react-select";
import DesviacionService from "../../../services/DesviacionService";
import ISearch from "../../../entities/helper/ISearch";
import { ROW_COUNT, ROW_COUNT_MAX } from "../../../helpers/variableHelper";
import { IComboboxOption } from "../../../entities/helper/IComboboxOption";
import UserPicker from "../../../controls/UserPicker";
import moment from "moment";
import IUserPickerValue from "../../../entities/helper/IUserPickerValue";
import ICurrentUser from "../../../entities/helper/ICurrentUser";
import { cognitoUserInfo } from "../../../helpers/userHelper";
import { E_EstadoCausa } from "../../../enums/E_EstadoCausa";
import { IAddCausaSistema, ICausaSistema } from "../../../entities/ICausaSistema";
import { IRequisitos } from "../../../entities/IRequisitos";
import { IRequisitoSistema } from "../../../entities/IRequisitoSistema";
import { dateFormatDiplay, dateFormatInputReference, shortDate } from "../../../helpers/dateHelper";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { ITipo_Campo } from "../../../helpers/IFormHelper";
import IDocumentoDesviacion, { ISearchDocsCausasEvidencias } from "../../../entities/IDocumentoDesviacion";
import { getFileName } from "../../../helpers/pathHelper";
import { ModalCausaObservaciones, ModalCausaRechazo, ModalConfirmacionCierre } from "./Modal/ModalCausaObservaciones";
import { ICausa } from "../../../entities/IDesviacion";
import { E_EstadoFormCausaDesviacion } from "../../../enums/E_EstadoFormulario";
import Loading from "../../../cross/Loading";
import { AdminListaPagination, IPagination } from "../../../controls/AdminListaPagination";
import RenderTitle from "../../../controls/RenderTitle";
import RenderValue from "../../../controls/RenderValue";
import IAuditoria from "../../../entities/IAuditoria";

interface IAgregarAnalisisCausalProps {
  token: string;
  idDesviacion: number;
  onClose: () => void;
  onSave: () => void;
  selectedAnalisisCausalCS?: ICausaSistema | null;
  estadoForm: E_EstadoFormCausaDesviacion;
  isVistaDetallada?: boolean;
  responsable?: string;
  responsableCierre?: string;
  items?: Array<IDocumentoDesviacion>;
  addSistema?: IAddCausaSistema;
  is_test?: boolean;
  selectedAudit: IAuditoria | null;
}
export default function AgregarAnalisisCausalSistema({
  token,
  idDesviacion,
  onClose,
  onSave,
  selectedAnalisisCausalCS,
  estadoForm,
  isVistaDetallada,
  responsable,
  responsableCierre,
  items,
  addSistema,
  is_test,
  selectedAudit,
}: IAgregarAnalisisCausalProps) {
  const [comboTRS, setComboTRS] = useState<Array<IRequisitos>>([]);
  const [comboDR, setComboDR] = useState<Array<IRequisitoSistema>>([]);
  const totalPagesListDocumentos = useRef<number>(0);
  const [valComboTRSCS, setValComboTRSCS] = useState<IComboboxOption | null>(
    selectedAnalisisCausalCS
      ? {
          label: selectedAnalisisCausalCS?.REQUISITOS,
          value: selectedAnalisisCausalCS?.ID_REQUISITOS.toString(),
        }
      : null
  );
  const [valComboDRCS, setvalComboDRCS] = useState<IComboboxOption | null>(
    selectedAnalisisCausalCS
      ? {
          label: selectedAnalisisCausalCS?.REQUISITO_SISTEMA,
          value: selectedAnalisisCausalCS?.ID_REQUISITO_SISTEMA.toString(),
        }
      : null
  );
  const refTxtAccionCS = React.createRef<HTMLTextAreaElement>();
  const [lenAccionCS, setLenAccionCS] = useState(0);
  const [valResponsableCS, setValResponsableCS] = useState<IUserPickerValue | null>(
    selectedAnalisisCausalCS
      ? {
          mail: selectedAnalisisCausalCS?.RESPONSABLE,
          name: selectedAnalisisCausalCS?.RESPONSABLE_DISPLAY,
        }
      : null
  );
  const refTxtFechaHastaCS = React.createRef<HTMLInputElement>();
  const [currentUserCS, setCurrentUserCS] = useState<ICurrentUser>();
  const [arrErrorEmptyCS, setArrErrorEmptyCS] = useState<string[]>([]);
  const [listDocumentosCS, setListDocumentosCS] = useState<Array<IDocumentoDesviacion>>(items || []);
  const [isSendingDataCS, setIsSendingDataCS] = useState(false);

  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const renderEstadoFormResponsable = () => {
    if (
      (responsableCierre && responsableCierre !== null) ||
      (selectedAudit?.AUDITORES_ACOMPANANTES && selectedAudit?.AUDITORES_ACOMPANANTES !== null)
    ) {
      return responsableCierre === currentUserCS?.email || isParticipatingAudit(selectedAudit?.AUDITORES_ACOMPANANTES, currentUserCS?.email);
    } else {
      return responsable === currentUserCS?.email;
    }
  };

  const isParticipatingAudit = (users: string | undefined, emailUser: string | undefined) => {
    if (users !== undefined && users !== null) {
      let arrayUsers = users.split("; ");
      const result = arrayUsers.some((user) => user.trim() === emailUser);
      return result;
    }
    return false;
  };

  const componentVer = (value: any) => {
    return (
      <i
        className="bi bi-search iconSearch"
        title="Ver Desviación"
        onClick={() => {
          DesviacionService.getContenidoDocumentoAnalisCausal(token, value.row.original.URL);
        }}></i>
    );
  };
  usePromiseEffect(async () => {
    let currUser = await cognitoUserInfo();
    setCurrentUserCS(currUser);
    await fillComboTCBCS();
    if (selectedAnalisisCausalCS) {
      await handleCargarDocumentosCS();
      await fillComboTCBCS();
      await fillComboFPCS(selectedAnalisisCausalCS.ID_REQUISITOS.toString());
      setLenAccionCS(selectedAnalisisCausalCS?.ACCION.length || 0);
    }
    console.log("renderEstadoFormResponsable", renderEstadoFormResponsable());
    console.log("estadoForm", estadoForm);
  }, []);

  const commoncs: ISearch = {
    ORDENADOPOR: "TITULO",
    ORIENTACION: "ASC",
    PAGINA: 1,
    PAGINADO: ROW_COUNT_MAX,
  };

  const fillComboTCBCS = async () => {
    const resultTCB = await DesviacionService.getListadoTipoRequisitoSistema(token, { ...commoncs });
    setComboTRS(resultTCB);
  };

  const fillComboFPCS = async (comboTRS?: string) => {
    const resultFP = await DesviacionService.getDescripcionRequisito(token, {
      ...commoncs,
      ID_REQUISITOS: parseInt(comboTRS as string),
      ACTIVO: true,
    });
    setComboDR(resultFP);
  };

  const validateFormCS = (value: IAddCausaSistema) => {
    let errors = [];
    if (!value.ID_REQUISITO_SISTEMA) {
      errors.push("ID_REQUISITO_SISTEMA");
    }
    if (!value.ID_REQUISITOS) {
      errors.push("ID_REQUISITOS");
    }
    if (!value.ACCION) {
      errors.push("ACCION");
    }
    if (!value.RESPONSABLE) {
      errors.push("RESPONSABLE");
    }
    if (!moment(value.FECHA_HASTA).isValid()) {
      errors.push("FECHA_HASTA");
    }
    setArrErrorEmptyCS(errors);

    return errors.length === 0;
  };

  const handleGuardarCausaBasicaCS = async () => {
    const value: IAddCausaSistema = {
      ID: selectedAnalisisCausalCS?.ID,
      ID_DESVIACION: idDesviacion,
      ID_REQUISITOS: parseInt(valComboTRSCS?.value as string),
      ID_REQUISITO_SISTEMA: parseInt(valComboDRCS?.value as string),
      ID_ESTADO: E_EstadoCausa.Asignada,
      ACCION: refTxtAccionCS.current?.value as string,
      RESPONSABLE: valResponsableCS?.mail as string,
      RESPONSABLE_DISPLAY: valResponsableCS?.name as string,
      FECHA_ASIGNACION: new Date(),
      FECHA_HASTA: new Date(refTxtFechaHastaCS.current?.value as string),

      FECHA_MODIFICACION: selectedAnalisisCausalCS ? new Date() : null,
      AUTOR: currentUserCS?.email as string,
      AUTOR_DISPLAY: currentUserCS?.fullname as string,
      EDITOR: null,
      EDITOR_DISPLAY: null,
      RECHAZO: null,
      FECHA_CREACION: selectedAnalisisCausalCS ? selectedAnalisisCausalCS.FECHA_CREACION : new Date(),
    };
    if (validateFormCS(value)) {
      setIsSendingDataCS(true);
      await DesviacionService.postCausaSistema(token, value);
      onSave();
      setIsSendingDataCS(false);
    }
  };

  const handleCerrarCausaCS = (estado: E_EstadoCausa) => {
    let val: ICausa = {
      ID: selectedAnalisisCausalCS?.ID as number,
      EDITOR: currentUserCS?.email as string,
      EDITOR_DISPLAY: currentUserCS?.fullname as string,
      ID_DESVIACION: idDesviacion,
      ID_ESTADO: estado,
      REQUIERE_CAMBIO_ESTADO: true,
      FECHA_ACCION_REALIZADA: selectedAnalisisCausalCS?.FECHA_ACCION_REALIZADA,
      FECHA_INGRESO_ACCION_REALIZADA: selectedAnalisisCausalCS?.FECHA_INGRESO_ACCION_REALIZADA,
    };

    if (estado === E_EstadoCausa.CerradoObservacion) {
      ModalCausaObservaciones(async (observacion: string) => {
        val.CON_OBSERVACION = estado === E_EstadoCausa.CerradoObservacion;
        val.OBSERVACIONES = observacion;
        setIsSendingDataCS(true);
        await DesviacionService.postAccionCierreCausaSistema(token, val);
        onSave();
      });
    } else if (estado === E_EstadoCausa.Cerrado) {
      ModalConfirmacionCierre(async () => {
        setIsSendingDataCS(true);
        await DesviacionService.postAccionCierreCausaSistema(token, val);
        onSave();
      });
    } else if (estado === E_EstadoCausa.Rechazada) {
      ModalCausaRechazo(async (motivoRechazo: string) => {
        val.MOTIVO_RECHAZO = motivoRechazo;
        val.RECHAZO = estado == E_EstadoCausa.Rechazada || null;
        setIsSendingDataCS(true);
        await DesviacionService.postAccionCierreCausaSistema(token, val);
        onSave();
      });
    }
  };

  const handleCargarDocumentosCS = async (pagination?: IPagination) => {
    let params: ISearchDocsCausasEvidencias = pagination
      ? {
          ...pagination,
          ID_CAUSA: selectedAnalisisCausalCS?.ID,
          ID_DESVIACION: idDesviacion,
        }
      : {
          ID_CAUSA: selectedAnalisisCausalCS?.ID,
          ID_DESVIACION: idDesviacion,
          ORDENADOPOR: "ID",
          ORIENTACION: "DESC",
          PAGINA: 1,
          PAGINADO: ROW_COUNT,
        };
    let resultDocumentos = is_test ? { data: items ?? [], pages: 10 } : await DesviacionService.getDocumentosCausasEvidencias(token, params);
    setListDocumentosCS(resultDocumentos.data);
    totalPagesListDocumentos.current = resultDocumentos.pages;
  };

  const columnHelperDocumentos = createColumnHelper<IDocumentoDesviacion>();
  let columnsDefDocumentos = [
    columnHelperDocumentos.accessor((rowcs) => rowcs.URL, {
      id: "URL",
      cell: (infocs: CellContext<IDocumentoDesviacion, string>) => componentValue(getFileName(infocs.getValue())),
      header: () => component("Nombre Documento"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDocumentos.accessor((rowcs) => rowcs.DESCRIPCION, {
      id: "DESCRIPCION",
      cell: (infocs: CellContext<IDocumentoDesviacion, string>) => componentValue(infocs.getValue()),
      header: () => component("Descripción"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDocumentos.accessor((rowcs) => rowcs.ID, {
      id: "VER",
      cell: (infocs: CellContext<IDocumentoDesviacion, string>) => componentVer(infocs),
      header: () => component("Ver"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
  ] as any;

  const error = (err: any) => {
    return arrErrorEmptyCS.includes(err) && "error";
  };

  return (
    <Offcanvas show={true} onHide={onClose} placement={"end"} className="w-50 modalAgregarCausa">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Ámbito de Gestión</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Row>
          <Col>
            <div className="row mb-2 ajusteInput">
              <button
                hidden={true}
                data-testid="btnvalidate"
                onClick={() => {
                  if (addSistema !== undefined) {
                    validateFormCS(addSistema);
                    handleGuardarCausaBasicaCS();
                  }
                  handleGuardarCausaBasicaCS();
                  handleCerrarCausaCS(E_EstadoCausa.CerradoObservacion);
                  handleCerrarCausaCS(E_EstadoCausa.Cerrado);
                  handleCerrarCausaCS(E_EstadoCausa.Rechazada);
                }}></button>
              <Col xs="12" md="6" lg="5">
                <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                <label>Tipo Ámbito de Gestión:</label>
              </Col>
              <Col xs="12" md="6" lg="7">
                {estadoForm === E_EstadoFormCausaDesviacion.Agregar ? (
                  <Select
                    options={comboTRS.map((vcc) => ({
                      value: vcc.ID.toString(),
                      label: vcc.TITULO,
                    }))}
                    className={`${error("ID_REQUISITOS")}`}
                    placeholder="Seleccione"
                    isClearable={true}
                    onChange={(e: SingleValue<IComboboxOption>) => {
                      setValComboTRSCS(e || null);
                      fillComboFPCS(e?.value);
                    }}
                    defaultValue={
                      selectedAnalisisCausalCS
                        ? {
                            value: selectedAnalisisCausalCS.ID_REQUISITOS,
                            label: selectedAnalisisCausalCS.REQUISITOS,
                          }
                        : ("" as any)
                    }
                  />
                ) : (
                  <span>{selectedAnalisisCausalCS?.REQUISITOS}</span>
                )}
              </Col>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="row mb-2 ajusteInput">
              <Col xs="12" md="6" lg="5">
                <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                <label>Descripción del Ámbito de Gestión:</label>
              </Col>
              <Col xs="12" md="6" lg="7">
                {estadoForm === E_EstadoFormCausaDesviacion.Agregar ? (
                  <Select
                    options={comboDR.map((vcc) => ({
                      value: vcc.ID,
                      label: vcc.TITULO,
                    }))}
                    className={`${error("ID_REQUISITO_SISTEMA")}`}
                    placeholder="Seleccione"
                    isClearable={true}
                    onChange={(e: any) => {
                      setvalComboDRCS(e || "");
                    }}
                    defaultValue={
                      selectedAnalisisCausalCS
                        ? {
                            value: selectedAnalisisCausalCS.ID_REQUISITO_SISTEMA,
                            label: selectedAnalisisCausalCS.REQUISITO_SISTEMA,
                          }
                        : ("" as any)
                    }
                  />
                ) : (
                  <span>{selectedAnalisisCausalCS?.REQUISITO_SISTEMA}</span>
                )}
              </Col>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="row mb-2 ajusteInput">
              <Col xs="12" md="6" lg="5">
                <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                <label>Acción:</label>
              </Col>
              <Col xs="12" md="6" lg="7">
                {estadoForm === E_EstadoFormCausaDesviacion.Agregar ? (
                  <span>
                    <textarea
                      ref={refTxtAccionCS}
                      className={`form-control form-control-sm ${error("ACCION")} borderGris`}
                      onChange={(e) => {
                        setLenAccionCS(e.target.value.length);
                      }}
                      defaultValue={selectedAnalisisCausalCS?.ACCION}
                      maxLength={1000}></textarea>
                    <span>{lenAccionCS}/1000</span>
                  </span>
                ) : (
                  <span>{selectedAnalisisCausalCS?.ACCION}</span>
                )}
              </Col>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="row mb-2 ajusteInput">
              <Col xs="12" md="6" lg="5">
                <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                <label>Responsable:</label>
              </Col>
              <Col xs="12" md="6" lg="7">
                {estadoForm === E_EstadoFormCausaDesviacion.Agregar ? (
                  <UserPicker
                    name={"detectadoPor"}
                    callback={(id, value) => {
                      setValResponsableCS(value?.shift() || null);
                    }}
                    id={"detectadoPor"}
                    key={"1"}
                    multi={false}
                    disabled={false}
                    className={`${error("ACCION")} borderColorGris`}
                    defaultValue={
                      selectedAnalisisCausalCS
                        ? {
                            mail: selectedAnalisisCausalCS.RESPONSABLE,
                            name: selectedAnalisisCausalCS.RESPONSABLE_DISPLAY,
                          }
                        : null
                    }
                  />
                ) : (
                  <span>{selectedAnalisisCausalCS?.RESPONSABLE_DISPLAY}</span>
                )}
              </Col>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="row mb-2 ajusteInput">
              <Col xs="12" md="6" lg="5">
                <label>Fecha de asignación:</label>
              </Col>
              <Col xs="12" md="6" lg="7">
                {moment(selectedAnalisisCausalCS ? selectedAnalisisCausalCS.FECHA_ASIGNACION : new Date()).format(dateFormatDiplay)}
              </Col>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="row mb-2 ajusteInput">
              <Col xs="12" md="6" lg="5">
                <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                <label>Fecha hasta:</label>
              </Col>
              <Col xs="12" md="6" lg="7">
                {estadoForm === E_EstadoFormCausaDesviacion.Agregar ? (
                  <Form.Control
                    ref={refTxtFechaHastaCS}
                    onChange={(e) => {}}
                    type="date"
                    className={`${error("FECHA_HASTA")}`}
                    defaultValue={selectedAnalisisCausalCS ? moment(selectedAnalisisCausalCS?.FECHA_HASTA).format(dateFormatInputReference) : ""}
                  />
                ) : (
                  <span>{shortDate(selectedAnalisisCausalCS?.FECHA_HASTA)}</span>
                )}
              </Col>
            </div>
          </Col>
        </Row>
        {selectedAnalisisCausalCS?.ID_ESTADO === E_EstadoCausa.Rechazada ? (
          <Row>
            <Col>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="5">
                  <label>Motivo rechazo:</label>
                </Col>
                <Col xs="12" md="6" lg="7">
                  <span>{selectedAnalisisCausalCS.MOTIVO_RECHAZO}</span>
                </Col>
              </div>
            </Col>
          </Row>
        ) : (
          <></>
        )}
        {isVistaDetallada && (
          <React.Fragment>
            <Row>
              <Col>
                <div className="row mb-2 ajusteInput">
                  <Col xs="12" md="6" lg="5">
                    <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                    <label>Fecha Acción Realizada:</label>
                  </Col>
                  <Col xs="12" md="6" lg="7">
                    <span>
                      {selectedAnalisisCausalCS?.FECHA_ACCION_REALIZADA
                        ? moment(selectedAnalisisCausalCS?.FECHA_ACCION_REALIZADA).format(dateFormatDiplay)
                        : ""}
                    </span>
                  </Col>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="row mb-2 ajusteInput">
                  <Col xs="12" md="6" lg="5">
                    <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                    <label>Fecha Ingreso Acción Realizada:</label>
                  </Col>
                  <Col xs="12" md="6" lg="7">
                    <span>
                      {selectedAnalisisCausalCS?.FECHA_INGRESO_ACCION_REALIZADA
                        ? moment(selectedAnalisisCausalCS?.FECHA_INGRESO_ACCION_REALIZADA).format(dateFormatDiplay)
                        : ""}
                    </span>
                  </Col>
                </div>
              </Col>
            </Row>
            {selectedAnalisisCausalCS?.ID_ESTADO === E_EstadoCausa.Rechazada && (
              <React.Fragment>
                <Row>
                  <Col>
                    <div className="row mb-2 ajusteInput">
                      <Col xs="12" md="6" lg="5">
                        <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                        <label>Motivo Rechazo:</label>
                      </Col>
                      <Col xs="12" md="6" lg="7">
                        <label>{selectedAnalisisCausalCS?.MOTIVO_RECHAZO}</label>
                      </Col>
                    </div>
                  </Col>
                </Row>
              </React.Fragment>
            )}
            {selectedAnalisisCausalCS?.ID_ESTADO === E_EstadoCausa.CerradoObservacion && (
              <React.Fragment>
                <Row>
                  <Col>
                    <div className="row mb-2 ajusteInput">
                      <Col xs="12" md="6" lg="5">
                        <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                        <label>Observación: </label>
                      </Col>
                      <Col xs="12" md="6" lg="7">
                        <label>{selectedAnalisisCausalCS?.OBSERVACIONES}</label>
                      </Col>
                    </div>
                  </Col>
                </Row>
              </React.Fragment>
            )}
            <Row>
              <Col>
                <div className="row mb-2 ajusteInput">
                  <Col xs="12" md="6" lg="5">
                    <span className="text-danger">{estadoForm === E_EstadoFormCausaDesviacion.Agregar && <strong>(*)</strong>}</span>
                    <span className="textSeccion">Carga Documentos Adjuntos:</span>
                  </Col>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <AdminListaPagination
                  defaultSortBy="ID"
                  sortDirection="DESC"
                  totalPages={totalPagesListDocumentos}
                  callback={async (pagination) => {
                    await handleCargarDocumentosCS(pagination);
                  }}
                  reload={async () => {
                    await handleCargarDocumentosCS();
                  }}
                  columnsDef={columnsDefDocumentos}
                  data={listDocumentosCS || []}
                  hideAdd={true}
                  hideReload={true}
                  hideExport={true}
                />
              </Col>
            </Row>
          </React.Fragment>
        )}
        <Row className="mb-2 ajusteInput mt-4">
          <Col xs="4" md="4" lg={estadoForm === E_EstadoFormCausaDesviacion.Cerrar ? "2" : "4"}></Col>
          {isSendingDataCS ? (
            <Loading />
          ) : (
            <Col xs="4" md="4" lg={estadoForm === E_EstadoFormCausaDesviacion.Cerrar ? "8" : "4"} className="text-center">
              {estadoForm === E_EstadoFormCausaDesviacion.Lectura || (
                <span>
                  {estadoForm === E_EstadoFormCausaDesviacion.Agregar && (
                    <button
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => {
                        handleGuardarCausaBasicaCS();
                      }}
                      disabled={isSendingDataCS}>
                      Guardar
                    </button>
                  )}
                  {estadoForm === E_EstadoFormCausaDesviacion.Cerrar && renderEstadoFormResponsable() ? (
                    <span>
                      <button
                        className="btn btn-sm btn-primary me-2"
                        onClick={() => {
                          handleCerrarCausaCS(E_EstadoCausa.Cerrado);
                        }}
                        disabled={isSendingDataCS}>
                        Cerrar
                      </button>
                      <button
                        className="btn btn-sm btn-primary me-2"
                        onClick={() => {
                          handleCerrarCausaCS(E_EstadoCausa.CerradoObservacion);
                        }}
                        hidden={true}
                        disabled={isSendingDataCS}>
                        Cerrar con Observaciones
                      </button>
                      <button
                        className="btn btn-sm btn-primary me-2"
                        onClick={() => {
                          handleCerrarCausaCS(E_EstadoCausa.Rechazada);
                        }}
                        hidden={true}
                        disabled={isSendingDataCS}>
                        Rechazar
                      </button>
                    </span>
                  ) : (
                    ""
                  )}
                </span>
              )}
              <button
                className="btn btn-sm btn-primary me-2"
                onClick={() => {
                  onClose();
                }}
                disabled={isSendingDataCS}>
                Volver
              </button>
            </Col>
          )}
          <Col xs="4" md="4" lg={estadoForm === E_EstadoFormCausaDesviacion.Cerrar ? "2" : "4"}></Col>
        </Row>
      </Offcanvas.Body>
    </Offcanvas>
  );
}
